"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGameBridge_1 = require("./useGameBridge");
function usePostMessage(action) {
    const gameBridge = (0, useGameBridge_1.default)();
    const postMessage = (0, react_1.useCallback)((payload) => {
        gameBridge.post(action, payload);
    }, [gameBridge, action]);
    return postMessage;
}
exports.default = usePostMessage;
